class ProductReview extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.videoStyle = this.dataset.videostyle || 'horizontal';
    this.init();
  }

  disconnectedCallback() {
    this.destroySlick($(this.querySelector('.reviewlist-wrapper')));
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.initReviewSlick($(this.querySelector('.reviewlist-wrapper')));
      this.initVideos();
    });
  }

  // Init Videos
  initVideos() {
    window.player = [];
    window.player_list = [];
    let videoRatio = this.videoStyle === 'vertical' ? "9:16" : "16:9";
    var ratioPc = videoRatio;
    var ratioMb = videoRatio;
    if(this.dataset.enablevideolist) {
      let videoLen = parseInt(this.dataset.videolen);
      for(let i = 1; i <= videoLen; i++) {
        let videoItem = this.querySelectorAll(`.video-self`)[i-1];
        ratioPc = `${videoItem.dataset.posterWidth} : ${videoItem.dataset.posterHeight}`;
        let ratio = window.innerWidth > 590 ? ratioPc : ratioMb;
        let temp_player = new Plyr(`#player-${i}`, {
          autoplay: false,
          loop: {
            active: false
          },
          controls: [
            'play', // Play/pause playback
            'progress', // The progress bar and scrubber for playback and buffering
            'captions', // Toggle captions
            'mute', // Toggle mute
            'fullscreen', // Toggle fullscreen,
          ],
          tooltips:{
            controls: true,
            seek: false
          },
          muted: true,
          captions: {
            active: true,
            language: 'auto',
            update: true
          },
          ratio: ratio,
          youtube: {
            playsinline: true, // 设置playsinline为false
            noCookie: true, // 禁用youtube cookie
            cc_lang_pref: 'en', // 设置字幕的语言
            cc_load_policy: 1, // 显示cc字幕
            modestbranding: 1, // 禁用/隐藏 YouTube 标志
            iv_load_policy: 3, // 视频注释: 1 - 启用； 3 - 禁用
          },
          ads: {
            enabled: false // 禁用广告
          },
          quality: {
            default: 1080,
            options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240]
          }
        });
        window.player[i] = temp_player;
        window.player_list.push(temp_player);
        temp_player.on('play', function(e) {
          for(let j = 1; j <= videoLen; j++) {
            if( j != i ){
              window.player[j].pause();
              window.player[j].stop();
            }
          }
        });
        window.player[i].on('ended', function(e) {
          e.detail.plyr.pause();
          e.detail.plyr.stop();
          // window.player[i].pause();
          // window.player[i].stop();
        });
      }
    }

    $(document).off(`click`, `.plyr--video`).on(`click`, `.plyr--video`, function (e) {
      e.stopPropagation();
      e.preventDefault();
      let vIndex = parseInt($(this).parent('.video-box').attr(`video-index`));
      let playingFlag = $(this).parent('.video-box').attr(`isplaying`);
      let vPlayer = window.player_list[vIndex - 1];
      if (playingFlag == 'isplaying') {
        if(!$(e.target).closest('.plyr__controls').length) {
          vPlayer.pause();
          $(this).parent('.video-box').attr('isplaying', '');
        }
      } else {
        vPlayer.play();
        $(this).parent('.video-box').attr('isplaying', 'isplaying');
      }
    });
    $(`.videolist-inner`).on('beforeChange', function (event, slick, currentSlide) {
      $(`.video-box.slick-active`).each(function () {
        let vIndex = parseInt($(this).attr(`video-index`));
        let vPlayer = window.player_list[vIndex - 1];
        if (vPlayer.playing) {
          vPlayer.pause();
          vPlayer.stop();
        }
      });
    });
    this.initVideoSlick($(this.querySelector('.videolist-inner')));
  }

  // Init Reviews Slick
  initReviewSlick(reviewlistWrapper = $(this.querySelector('.reviewlist-wrapper'))) {
    if (reviewlistWrapper.length) {
      // Hide dots if there is only one dot
      reviewlistWrapper.on('init', function(event, slick) {
        if($(this.querySelectorAll(`.slick-dots li`)).length <= 1) {
          $(this.querySelector(`.slick-dots`)).hide();
        }
      });
      reviewlistWrapper.slick({
        infinite: true,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="review-list-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="review-list-prev">Prev Review</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="review-list-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="review-list-next">Next Review</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
        responsive: [
          {
            breakpoint: 590,
            settings: {
              slidesToShow: 1,
              dots: true,
            },
          },
        ],
      });
    }
  }

  // Init Videos Slick
  initVideoSlick(videolistWrapper = $(this.querySelector('.videolist-inner'))) {
    if (videolistWrapper.length) {
      // Hide dots if there is only one dot
      videolistWrapper.on('init', function(event, slick){
        if($(this.querySelectorAll(`.slick-dots li`)).length <= 1) {
          $(this.querySelector(`.slick-dots`)).hide();
        }
      });

      var tempResponsive = [];
      if(this.videoStyle === 'vertical') {
        tempResponsive = [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 590,
            settings: {
              slidesToShow: 2,
              arrows: false,
              dots: true
            }
          }
        ];
      } else {
        tempResponsive = [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 590,
            settings: {
              slidesToShow: 1,
              arrows: false,
              dots: true
            }
          }
        ];  
      }
      
      videolistWrapper.slick({
        infinite: false,
        draggable: false,
        slidesToShow: this.videoStyle === 'vertical' ? 5 : 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="video-list-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="video-list-prev">Prev</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="video-list-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="video-list-next">Next</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
        responsive: tempResponsive
      });
    }
  }

  // Destroy Slick
  destroySlick(slickWrapper = $(this.querySelector('.reviewlist-wrapper'))) {
    if (slickWrapper.hasClass('slick-initialized')) {
      slickWrapper.slick('unslick');
    }
  }
}

// 注册自定义元素
customElements.define("product-review", ProductReview);
